import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  template: `
    <div class="bd-container">
      <div class="flex flex-row justify-center">
        <div>
          <i class="pi pi-wrench" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div class="bd-container-inner">
      <h1 class="text-xl font-semibold m-0">
        Wir überarbeiten diesen Bereich gerade für Sie
      </h1>
      <p>
        Danke für Ihr Verständnis! Wir beeilen uns, damit Sie so schnell wie
        möglich wieder wie gewohnt darauf zugreifen können. Bis dahin können Sie
        gerne unseren Support kontaktieren.
      </p>
    </div>
  `,
  styles: [
    `
      i.pi {
        font-size: 100px;
      }

      h1 {
        text-align: center;
      }

      p {
        text-align: center;
      }
    `,
  ],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class BdFeatureStatusMaintenanceComponent {}
